<template>
  <div class="top-bar color-scheme-transparent p-0">

    <div
        v-if="companyKey === 'BSG'"
        class="text-center p-3 w-100" style="font-size: 16px;">
      Willkommen zur neuen Version unseres CRM.<br>
      Wir hoffen es gefällt dir! Sollten dir Fehler auffallen, melde dich bitte mit einer Fehlerbeschreibung bei Mirco Siegmund (m.siegmund@bildung-sg.de)
    </div>

    <!-- TIME MANAGEMENT -->
    <!--        <router-link v-if="-->
    <!--             currentUserRole === 'ROLE_PERSONAL' ||-->
    <!--             currentUserRole === 'ROLE_HEAD_OF_HR'"-->
    <!--                     :to="{ name: 'tmPendingMonthsForApproval' }">-->
    <!--          <div class="messages-notifications">-->
    <!--            <i class="os-icon os-icon-calendar-time"-->
    <!--               data-title="Time management"-->
    <!--               data-bs-toggle="tooltip"-->
    <!--               style="color: #43ad4e">-->
    <!--            </i>-->
    <!--            <div v-if="countTimeManagementMonthForApproval > 0" class="new-messages-count" style="color: white">-->
    <!--              {{ countTimeManagementMonthForApproval }}-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </router-link>-->

    <!-- HOLIDAY -->
    <!--        <router-link :to="{ name: 'holidayPendingRequestList' }">-->
    <!--          <div class="messages-notifications">-->
    <!--            <i class="os-icon os-icon-sun"-->
    <!--               data-title=Urlaube-->
    <!--               data-bs-toggle="tooltip"-->
    <!--               style="color: #43ad4e">-->
    <!--            </i>-->
    <!--            <div v-if="countPendingHolidayRequest > 0" class="new-messages-count" style="color: white">-->
    <!--              {{ countPendingHolidayRequest }}-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </router-link>-->

    <!-- SICK DAYS  -->
    <!--        <router-link :to="{ name: 'reportSickDaysPendingRequestList' }">-->
    <!--          <div class="messages-notifications">-->
    <!--            <i class="os-icon os-icon-newspaper"-->
    <!--               data-title=Krankheitstage-->
    <!--               data-bs-toggle="tooltip"-->
    <!--               style="color: #43ad4e">-->
    <!--            </i>-->
    <!--            <div v-if="countPendingRequestForSickDays > 0" class="new-messages-count">-->
    <!--              !-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </router-link>-->


    <div class="top-menu-controls d-flex d-lg-none" v-if="isLoaded">
      <div class="d-flex" v-if="
            currentUserRole === 'ROLE_ADMIN' ||
            currentUserRole === 'ROLE_PERSONAL' ||
            currentUserRole === 'ROLE_HEAD_OF_HR' ||
            currentUserRole === 'ROLE_SITE_MANAGER' ||
            currentUserRole === 'ROLE_HEAD_OF_AMDL' ||
            currentUserRole === 'ROLE_HEAD_OF_MARKETING' ||
            currentUserRole === 'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES' ||
            currentUserRole === 'ROLE_HEAD_OF_OCCUPATIONAL_THERAPY'">

        <!-- PRIVATE COACHING INQUIRY  -->
        <router-link :to="{ name: 'privateCoachingInquiryOverviewListForCoach' }">
          <div class="messages-notifications" style="margin:0">
            <i
                class="fa-solid fa-file-lines"
                data-title="Anfrage"
                data-bs-toggle="tooltip"
                :style="{ color: 'var(--primary)', fontSize: '25px', width: '40px' }">
            </i>
            <div v-if="countInquiryNotificationForCoach > 0"
                 class="new-messages-count" style="color: white">
              {{ countInquiryNotificationForCoach }}
            </div>
          </div>
        </router-link>

        <!-- TRAVEL EXPENSES -->
        <router-link
            v-if="companySettings.travelExpensesEnabled && piniaCurrentUser.engagementType !== 'extern'"
            :to="{ name: 'travelExpensesPendingAndActiveListForCoordinator' }">
          <div class="messages-notifications">
            <i
                class="fas fa-car-side car-icon"
                :style="{ color: 'var(--primary)', fontSize: '25px', width: '40px' }"
                data-title="Fahrtkosten"
                data-bs-toggle="tooltip"
                data-bs-placement="top">
            </i>
            <div v-if="countTravelExpensesNotification > 0"
                 class="new-messages-count">
              !
            </div>
          </div>
        </router-link>
      </div>


      <!-- ACTIONS FOR COACH ONLY -->
      <!-- Coach bill ( for external coordinators )-->
      <div class="d-flex" v-if="currentUserRole === 'ROLE_COACH'">
        <router-link :to="{ name: 'coachBillingCoordinatorPendingBills' }"
                     v-if="piniaCurrentUser.engagementType === 'extern'">
          <div class="messages-notifications">
            <i class="fas fa-bell"
               :style="{ color: 'var(--primary)', fontSize: '25px', width: '40px' }"
               data-title="Rechnungen"
               data-bs-toggle="tooltip">
            </i>
            <div v-if="countPendingBillsForExternalCoordinator > 0"
                 class="new-messages-count" style="color: white">
              {{ countPendingBillsForExternalCoordinator }}
            </div>
          </div>
        </router-link>

        <!-- Private coaching inquiry -->
        <router-link :to="{ name: 'privateCoachingInquiryOverviewListForCoach' }">
          <div class="messages-notifications">
            <i
                class="fa-solid fa-file-lines"
                data-title="Anfrage"
                data-bs-toggle="tooltip"
                :style="{ color: 'var(--primary)', fontSize: '25px', width: '40px' }">
            </i>
            <div v-if="countInquiryNotificationForCoach > 0"
                 class="new-messages-count" style="color: white">
              {{ countInquiryNotificationForCoach }}
            </div>
          </div>
        </router-link>
      </div>

      
      <!-- FOR ACCOUNTANT -->
      <div class="d-flex" v-if="currentUserRole === 'ROLE_ACCOUNTANT'">
        <!-- Coach bill notifications -->
        <router-link :to="{
          name: 'coachBillingPendingBills',
          query: { withMessage: 1 }
        }">
          <div class="messages-notifications">
            <i class="fas fa-bell"
               :style="{ color: 'var(--primary)', fontSize: '25px', width: '40px' }"
               data-title="Rechnungen"
               data-bs-toggle="tooltip">
            </i>
            <div v-if="countUnreadMessagesForAccountant > 0" class="new-messages-count">
              !
            </div>
          </div>
        </router-link>
      </div>

    </div>
  </div>
</template>

<script setup>
import { piniaUserStore } from '@/store/piniaUserStore';
import { computed, defineProps, toRefs } from 'vue';
import {piniaCompanySettingsStore} from "@/store/piniaCompanySettingsStore";

const piniaUserState   = piniaUserStore();
const piniaCurrentUser = computed(() => piniaUserState.currentUser.user);
const currentUserRole  = piniaCurrentUser?.value?.roles[ 0 ];
const piniaCompanySettingsState = piniaCompanySettingsStore()
const companySettings = computed(() => piniaCompanySettingsState.companySettings)
const companyKey = companySettings.value.companyKey;

const props = defineProps({
  countTravelExpensesNotification: {
    type: Number,
    required: true,
    default: 0,
  },
  countPendingBillsForExternalCoordinator: {
    type: Number,
    required: true,
    default: 0,
  },
  countInquiryNotificationForCoach: {
    type: Number,
    required: true,
    default: 0,
  },
  countUnreadMessagesForAccountant: {
    type: Number,
    required: true,
  },
  isLoaded: {
    type: Boolean,
    required: true,
    default: false,
  },
});

const countTravelExpensesNotification         = toRefs(props)[ 'countTravelExpensesNotification' ];
const countPendingBillsForExternalCoordinator = toRefs(props)[ 'countPendingBillsForExternalCoordinator' ];
const countInquiryNotificationForCoach        = toRefs(props)[ 'countInquiryNotificationForCoach' ];
const countUnreadMessagesForAccountant        = toRefs(props)[ 'countUnreadMessagesForAccountant' ];
const isLoaded                                = toRefs(props)[ 'isLoaded' ];
</script>

<style scoped>

</style>